import React from 'react';
import { HelpCircle, Layers, Clock, ArrowRight } from 'lucide-react';
import { SUBSCRIPTION_INSIGHTS } from '../../data/ipoSubscriptionData';

export const SubscriptionInsights = () => {
  const getIcon = (id) => {
    switch (id) {
      case 'qib':
        return <HelpCircle className="w-4 h-4 text-indigo-600" />;
      case 'nii':
        return <Layers className="w-4 h-4 text-amber-600" />;
      case 'timings':
        return <Clock className="w-4 h-4 text-emerald-600" />;
      default:
        return <HelpCircle className="w-4 h-4 text-indigo-600" />;
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mt-6">
      {SUBSCRIPTION_INSIGHTS.map((item) => (
        <div
          key={item.id}
          className="bg-white rounded-2xl border border-slate-200/90 p-5 shadow-xs hover:border-indigo-300 transition-all flex flex-col justify-between"
        >
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-7 h-7 rounded-lg bg-slate-50 border border-slate-200 flex items-center justify-center">
                {getIcon(item.id)}
              </div>
              <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                {item.tag}
              </span>
            </div>

            <h4 className="font-bold text-sm sm:text-base text-slate-900 mt-1">
              {item.title}
            </h4>
            <p className="text-xs text-slate-600 mt-1.5 leading-relaxed">
              {item.desc}
            </p>
          </div>

          {/* <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between">
            <span className="text-[11px] font-medium text-slate-400">Institutional Guide</span>
            <a
              href={`#learn-${item.id}`}
              className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-600 hover:text-indigo-700"
            >
              <span>Read Guide</span>
              <ArrowRight className="w-3 h-3" />
            </a>
          </div> */}
        </div>
      ))}
    </div>
  );
};

export default SubscriptionInsights;
